// Payment enforcement & dunning state. See plans/saas-billing/06-payment-enforcement-dunning.md.
//
// Three-tier state distinction:
//   - Stripe 'active' (or cancelled-in-grace) -> level: 'none'
//   - Stripe 'past_due' + Solo grace days 0-7 -> level: 'past_due'
//   - Stripe 'past_due' + Solo grace days 8-21 -> level: 'restricted'
//   - Stripe 'unpaid' (retries exhausted) -> level: 'restricted'
//
// NOTE: The doc spec defines EnforcementSeverity as 'info' | 'warning' | 'urgent' | 'blocked'.
// This prototype implements the simpler 'yellow' | 'orange' | 'red' palette per the build spec
// (used directly in CSS class names and banner copy). The two are 1:1 mappable:
//   info=yellow, warning=orange, urgent/blocked=red.

export type EnforcementLevel = 'none' | 'past_due' | 'restricted';

export type EnforcementSeverity = 'yellow' | 'orange' | 'red';

export type RestrictedFeature = 'ai_chat' | 'create_record' | 'background_jobs';

export interface EnforcementStatus {
  level: EnforcementLevel;
  severity?: EnforcementSeverity;
  /** Whole days remaining in the Solo grace window. Null when level === 'none'. */
  daysRemaining?: number;
  /** ISO 8601. Mirrors Subscription.pastDueSince. */
  pastDueSince?: string;
  /** ISO 8601. Mirrors Subscription.gracePeriodEndsAt. */
  gracePeriodEndsAt?: string;
  /** Empty unless level === 'restricted'. Ordered by enforcement priority. */
  restrictedFeatures: RestrictedFeature[];
  /** Always '/billing' in v1 so the user can fix payment. */
  ctaUrl: string;
}
